(function(){
  function load(video){
    if(!video || video.dataset.loaded === 'true') return;
    var src = video.getAttribute('data-src');
    if(!src) return;
    video.dataset.loaded = 'true';
    var source = document.createElement('source');
    source.setAttribute('src', src);
    source.setAttribute('type', 'video/mp4');
    video.appendChild(source);
    video.load();
    video.addEventListener('canplay', function(){
      video.classList.add('is-ready');
      var p = video.play();
      if(p && p.catch) p.catch(function(){});
    }, {once:true});
  }

  function onFirstInteraction(callback){
    var done = false;
    var events = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    function run(){
      if(done) return;
      done = true;
      events.forEach(function(event){
        window.removeEventListener(event, run);
      });
      callback();
    }
    events.forEach(function(event){
      window.addEventListener(event, run, {once:true, passive:true});
    });
  }

  function afterPosterPaint(video, callback){
    var poster = video.parentElement && video.parentElement.querySelector('.deferred-video-poster img');
    var delay = 3200;

    function schedule(){
      window.requestAnimationFrame(function(){
        window.requestAnimationFrame(function(){
          window.setTimeout(callback, delay);
        });
      });
    }

    if(poster && !poster.complete){
      poster.addEventListener('load', schedule, {once:true});
      poster.addEventListener('error', schedule, {once:true});
    } else {
      schedule();
    }
  }

  function schedule(video){
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

    if(isMobile){
      onFirstInteraction(function(){load(video);});
      afterPosterPaint(video, function(){load(video);});
      return;
    }

    if('requestIdleCallback' in window){
      window.requestIdleCallback(function(){load(video);}, {timeout:2200});
    } else {
      window.setTimeout(function(){load(video);}, 1600);
    }
  }

  function init(){
    document.querySelectorAll('[data-hero-deferred-video]').forEach(schedule);
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
